import React from "react";
import { Modal, Button } from "react-bootstrap";

const ScrapDetailModal = ({ show, onHide, scrap }) => {
  if (!scrap) return null;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Data Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {scrap.id_user ? scrap.id_user.name : "N/A"}
        </p>
        <p>
          <strong>Phone Number:</strong>{" "}
          {scrap.id_user ? scrap.id_user.phonenumber : "N/A"}
        </p>
        <p>
          <strong>Vehicle:</strong>{" "}
          {scrap.id_vehicle ? scrap.id_vehicle.numberplate : "N/A"}
        </p>
        <p>
          <strong>Actual Vehicle:</strong>{" "}
          {scrap.actual_vehicle ? scrap.actual_vehicle.numberplate : "N/A"}
        </p>

        <p>
          <strong>Client:</strong>{" "}
          {scrap.id_client ? scrap.id_client.name : "N/A"}
        </p>

        <p>
          <strong>Comments:</strong> {scrap.comments}
        </p>
        <p>
          <strong>Created Date:</strong> {formatDate(scrap.createdAt)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScrapDetailModal;
